
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4250"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4250"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cP3LP", function(module, exports) {

$parcel$export(module.exports, "getClassData", () => $955d2c31eafd4c00$export$3f5d7aac17789983);
$parcel$export(module.exports, "getJsonFromElement", () => $955d2c31eafd4c00$export$6be7b37ff53da754);
function $955d2c31eafd4c00$export$3f5d7aac17789983(element) {
    while(element !== null){
        // Vérifie si l'élément courant a la classe 'data'
        if (element.classList.contains("data")) return element;
        element = element.parentElement;
    }
    return null;
}
function $955d2c31eafd4c00$export$6be7b37ff53da754(element) {
    const json = {};
    // Trouver tous les descendants qui ont la classe 'entry'
    const entries = element.querySelectorAll(".entry");
    entries.forEach((entry)=>{
        const title = entry.getAttribute("title");
        let value;
        if (entry.tagName.toLowerCase() === "input") {
            if (entry.type === "text") json[title] = entry.value.trim();
            else if (entry.type === "checkbox") json[title] = entry.checked;
            else json[title] = entry.value.trim();
        } else if (entry.tagName.toLowerCase() === "ul") {
            const listResult = [];
            const listItems = entry.querySelectorAll(".item");
            listItems.forEach((listItem)=>{
                const listItemTitle = listItem.getAttribute("title");
                if (listItem.tagName.toLowerCase() === "input") {
                    if (listItem.type === "text") listResult.push(listItem.value.trim());
                    else if (listItem.type === "checkbox") {
                        if (listItem.checked) listResult.push(listItem.title);
                    } else listResult.push(listItem.value.trim());
                }
            });
            json[title] = listResult;
        } else json[title] = entry.textContent.trim();
    });
    return json;
}

});

parcelRegister("gApu6", function(module, exports) {

$parcel$export(module.exports, "api", () => $2729d7a6498e4ddb$export$644d8ea042df96a6);
const $2729d7a6498e4ddb$var$STORAGE_KEY = "PUBLIC_SURVEY_IDENTITY";
function $2729d7a6498e4ddb$var$generateCooperativeBrowserIdentity() {
    return new Date().toISOString().split("T")[0] + "_" + Math.floor(Math.random() * 1000000);
}
function $2729d7a6498e4ddb$export$acc9bcaae878c209() {
    let id = localStorage.getItem($2729d7a6498e4ddb$var$STORAGE_KEY);
    if (!id) {
        id = $2729d7a6498e4ddb$var$generateCooperativeBrowserIdentity();
        localStorage.setItem($2729d7a6498e4ddb$var$STORAGE_KEY, id);
    }
    return {
        cooperative_browser: id
    };
}
function $2729d7a6498e4ddb$export$1617268687ac763c() {
    const url = new URL(document.URL);
    const params = url.searchParams;
    if (params.has("identity")) return JSON.parse(params.get("identity"));
    else if (params.has("anonymous")) return null // {userId : "anonymous"}
    ;
    else if (params.has("browserid")) return $2729d7a6498e4ddb$export$acc9bcaae878c209();
    else if (params.has("user")) return {
        credentials: {
            user: params.get("user"),
            password: params.get("password")
        }
    };
    else return $2729d7a6498e4ddb$export$acc9bcaae878c209();
}
function $2729d7a6498e4ddb$export$68b378e7c2dd98d3() {
    const url = new URL(document.URL);
    if (url.searchParams.has("api_endpoint")) {
        const endpoint = url.searchParams.get("api_endpoint");
        return new URL(endpoint).toString();
    }
    if (url.hostname.includes("localhost")) return `http://localhost:4000/`;
    else return `${url.origin}/api/`;
}
async function $2729d7a6498e4ddb$export$644d8ea042df96a6(route, body) {
    while(route.startsWith("/"))route = route.slice(1);
    const url = $2729d7a6498e4ddb$export$68b378e7c2dd98d3() + route;
    let options = {};
    const userId = $2729d7a6498e4ddb$export$1617268687ac763c();
    if (userId) body = {
        ...body || {},
        userId: userId
    };
    if (body) options = {
        ...options,
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "content-type": "application/json"
        }
    };
    const response = await fetch(url, options);
    if (!response.ok) {
        const message = await response.text();
        throw `api returned ${response.statusText} : ${message}`;
    }
    let result = null;
    try {
        result = await response.json();
    } catch (err) {
        throw `result is not a json`;
    }
    return result;
}

});


var $cP3LP = parcelRequire("cP3LP");

var $gApu6 = parcelRequire("gApu6");
document.addEventListener("DOMContentLoaded", ()=>{
    const surveysList = document.getElementById("surveysList");
    const currentHostname = document.location.hostname;
    let API_URL = `http://localhost:4000/surveys`;
    console.log("API_URL", API_URL);
    let charts = {}; // Object to hold chart instances
    const submitVote = async (element)=>{
        const classData = (0, $cP3LP.getClassData)(element);
        console.log(classData);
        const jsonFromSurvey = (0, $cP3LP.getJsonFromElement)(classData);
        console.log(jsonFromSurvey);
        try {
            const response = await (0, $gApu6.api)(`/surveys/${element.id}/vote`, jsonFromSurvey);
            console.log(response);
        } catch (err) {
            console.error(err);
            document.querySelector("#debug").innerHTML = err.toString();
        }
    };
    const loadSurvey = async (survey)=>{
        const li = document.createElement("li");
        li.classList.add("data");
        const title = document.createElement("h3");
        title.textContent = `${survey.title}`;
        title.classList.add("entry");
        title.title = "title";
        li.appendChild(title);
        const responsesForm = document.createElement("ul");
        responsesForm.classList.add("responsesForm");
        responsesForm.classList.add("entry");
        responsesForm.title = "choice";
        responsesForm.dataset.surveyId = survey._id;
        survey.choices.forEach((choice, index)=>{
            const label = document.createElement("label");
            const nbVotes = `${survey.result.cmulated[choice] || 0}`;
            label.textContent = `${choice} - Votes: ${nbVotes}`;
            label.classList.add("form-check-label");
            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.name = "responseIndex";
            checkbox.title = choice;
            checkbox.value = index;
            checkbox.classList.add("form-check-input");
            checkbox.classList.add("me-1");
            checkbox.classList.add("item");
            label.prepend(checkbox);
            responsesForm.appendChild(label);
            responsesForm.appendChild(document.createElement("br"));
        });
        // Ajout de la liste de bouton par sondage
        const buttonForm = document.createElement("div");
        buttonForm.classList.add("d-flex");
        //Ajout du bouton pour voter
        const submitButton = document.createElement("button");
        submitButton.textContent = "Vote";
        submitButton.id = survey._id;
        submitButton.classList.add("test");
        submitButton.classList.add("btn");
        submitButton.classList.add("btn-outline-success");
        submitButton.addEventListener("click", async (evt)=>{
            await submitVote(evt.target);
            await loadSurveys();
        });
        buttonForm.appendChild(submitButton);
        // Ajout du bouton et du conteneur pour le camembert
        const resultsButton = document.createElement("button");
        resultsButton.textContent = "Display results";
        resultsButton.classList.add("btn");
        resultsButton.classList.add("btn-outline-success");
        resultsButton.addEventListener("click", ()=>{
            console.log(survey._id);
            toggleResults(survey);
        });
        buttonForm.appendChild(resultsButton);
        responsesForm.appendChild(buttonForm);
        li.appendChild(responsesForm);
        const chartContainer = document.createElement("div");
        chartContainer.classList.add("chartContainer");
        chartContainer.style.display = "none";
        chartContainer.innerHTML = `<canvas id="chart-${survey._id}"></canvas>`;
        li.appendChild(chartContainer);
        li.classList.add("list-group-item");
        surveysList.appendChild(li);
    };
    // Fonction pour charger les sondages
    const loadSurveys = async ()=>{
        try {
            const json = await (0, $gApu6.api)("surveys");
            console.log(json);
            surveysList.innerHTML = "";
            console.log("");
            json.forEach((survey)=>{
                console.log(survey);
                loadSurvey(survey);
            });
        } catch (error) {
            console.error("Erreur lors du chargement des sondages:", error);
        }
    };
    const toggleResults = (survey)=>{
        const chartContainer = document.querySelector(`#chart-${survey._id}`).parentElement;
        if (chartContainer.style.display === "none") {
            chartContainer.style.display = "block";
            showResults(survey);
        } else {
            chartContainer.style.display = "none";
            if (charts[survey._id]) {
                charts[survey._id].destroy();
                delete charts[survey._id];
            }
        }
    };
    const showResults = async (survey)=>{
        try {
            const votes = [];
            survey.choices.forEach((choice)=>{
                console.log(choice);
                votes.push(survey.result[choice] || 0);
            });
            const data = {
                labels: survey.choices,
                datasets: [
                    {
                        label: "Votes",
                        data: survey.result,
                        backgroundColor: [
                            "rgba(255, 99, 132, 0.2)",
                            "rgba(54, 162, 235, 0.2)",
                            "rgba(255, 206, 86, 0.2)",
                            "rgba(75, 192, 192, 0.2)",
                            "rgba(153, 102, 255, 0.2)",
                            "rgba(255, 159, 64, 0.2)"
                        ],
                        borderColor: [
                            "rgba(255, 99, 132, 1)",
                            "rgba(54, 162, 235, 1)",
                            "rgba(255, 206, 86, 1)",
                            "rgba(75, 192, 192, 1)",
                            "rgba(153, 102, 255, 1)",
                            "rgba(255, 159, 64, 1)"
                        ],
                        borderWidth: 1
                    }
                ]
            };
            const ctx = document.getElementById(`chart-${survey._id}`).getContext("2d");
            charts[survey._id] = new Chart(ctx, {
                type: "pie",
                data: data,
                options: {
                    responsive: true
                }
            });
        } catch (error) {
            console.error("Erreur lors de la r\xe9cup\xe9ration des r\xe9sultats:", error);
        }
    };
    // Charger les sondages au démarrage
    loadSurveys();
});


//# sourceMappingURL=index.39cb601a.js.map
